<template>
<!-- 计费模板页面-service账号查看的旧版本，已不使用 -->
  <div>
    <div class="platformSearch" style="margin-left:10px;">
      <Form :model="pageSearchParams">
        <Row>
          <Col span="3">
            <Form-item>
              <Input v-model.trim="pageSearchParams.searchLogisName" style="width: 180px" :placeholder="$t('common.searchLogisName')"></Input>
            </Form-item>
          </Col>
          <Col span='2'>
            <Button type="primary" v-once icon="search" @click="logisSearch">{{$t('common.search')}}</Button>
          </Col>
          <Col span="3" style="margin-left:12px;">
            <Form-item>
              <Input v-model.trim="pageSearchParams.searchShipName" style="width: 180px" :placeholder="$t('common.searchChannelName')"></Input>
            </Form-item>
          </Col>
          <Col span='2'>
            <Button type="primary" v-once icon="search" @click="chanInfoSearch">{{$t('common.search')}}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <Row>
      <Col :span="5">
        <div class="custom" :style="{height: (tableHeight + 60) + 'px'}">
          <!-- 物流商 -->
          <dTable highlight-row :columns="logisticProviderColumns" :data="logisticProviderData" :height="tableHeight" @on-current-change="currentChange" style="cursor:pointer;"></dTable>
          <div class="pageChange fr">
            <Page size="small" :total="logisticProviderTotal" @on-change="changePage" show-total :page-size="pageParams.pageSize" :current="pageParams.pageNum"></Page>
          </div>
        </div>
      </Col>
      <Col :span="18" style="margin-left:20px;">
        <div class="baseInformation" :style="{height: (tableHeight + 50) + 'px'}">
          <!-- 渠道列表 -->
          <dTable highlight-row border :columns="channelColumns" :height="tableHeight" :data="channelData"></dTable>
          <div class="table-page">
            <div class="table-page-right">
              <Page :total="channelTotal" @on-change="channelChangePage" show-total :page-size="channelParams.pageSize" show-elevator :current="channelParams.pageNum" show-sizer @on-page-size-change="channelChangePageSize" placement="top" :page-size-opts="pageArray"></Page>
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <!-- 计费模型 -->
    <Modal v-model="pricingModal" @on-cancel="pricingCancel" v-if="pricingModelStatus" :mask-closable="false" width="1300">
      <p slot="header" style="color:#113f6d;text-align:left">
        <Icon type="information-circled"></Icon>
        <span style="color:#fff">{{$t('logisticsProvider.chargingModel')}}</span>
      </p>
      <pricingModelOld ref="pricingModel" :editFlag="editFlag" :timestamp="timestamp" :shippingMethodId="shippingMethodId"></pricingModelOld>
      <span slot="footer"></span>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import pricingModelOld from './pricingModel_old';
export default {
  mixins: [ Mixin ],
  components: {
    pricingModelOld
  },
  data () {
    let self = this;
    return {
      pageParamsStatus: false, // 是否重新加载物流商列表数据
      channelParamsStatus: false, // 是否重新加载渠道列表数据
      pricingModal: false,
      pricingModelStatus: false,
      shippingMethodId: null,
      timestamp: 0,
      pageParams: {
        pageSize: 10,
        pageNum: 1
      },
      pageSearchParams: {
        searchLogisName: '', // 物流商名称
        searchShipName: '' // 渠道名称
      },
      channelParams: {
        pageSize: 10,
        pageNum: 1
      },
      logisticProviderColumns: [
        {
          title: self.t('logisticsProvider.shipment'),
          align: 'center',
          key: 'carrierName'
        }
      ],
      channelColumns: [
        {
          title: 'NO.',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1);
          }
        },
        {
          title: self.t('logisticsProvider.channelNum'),
          key: 'shippingMethodCode',
          minWidth: 150,
          maxWidth: 300,
          align: 'center'
        },
        {
          title: self.t('logisticsProvider.channelName'),
          key: 'shippingMethodName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: self.t('common.operation'),
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  self.pricingModelStatus = true;
                  let date = new Date().getTime();
                  self.timestamp = date;
                  self.shippingMethodId = params.row.shippingMethodId;
                  self.$nextTick(function () {
                    self.pricingModal = true;
                    self.editFlag = false;
                  });
                }
              }
            }, self.t('logisticsProvider.setChargModel'));
          }
        }
      ],
      channelData: [],
      logisticProviderData: [],
      logisticProviderTotal: 0,
      channelTotal: 0,
      shipModalData1: [],
      editFlag: false,
      carrId: '' // 切换物流商ID
    };
  },
  methods: {
    getList () {
      let v = this;
      let pos = [];
      var obj = {
        carrierName: v.pageSearchParams.searchLogisName ? v.pageSearchParams.searchLogisName : null, // 物流商名称
        pageSize: v.pageParams.pageSize,
        pageNum: v.pageParams.pageNum
      };
      v.axios.post(api.get_logisticProviderList, obj) // 获取物流商列表
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas.list;
            data.forEach((n, i) => {
              pos.push({
                carrierName: n.carrierName,
                carrierId: n.carrierId
              });
            });
            v.logisticProviderData = pos;
            if (pos.length > 0 && v.pageParams.pageNum === 1) {
              // v.getChannelList(pos[0].carrierId);
              // v.getChannelList();
              // v.channelParams.pageNum = 1;
              v.chanInfoSearch();
            }
            v.logisticProviderTotal = response.data.datas.total;
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    },
    // 物流商名称查询
    logisSearch () {
      let v = this;
      v.pageParams.pageNum = 1; // 页码重置为1
      v.getList();
    },
    // 渠道名称查询
    chanInfoSearch () {
      let v = this;
      v.channelParams.pageNum = 1; // 页码重置为1
      v.getChannelList();
    },
    // 点击切换物流商
    currentChange (currentRow, oldCurrentRow) {
      let v = this;
      v.carrId = currentRow.carrierId;
      v.getChannelList();
      v.channelParams.pageNum = 1;
    },
    // 获取渠道列表
    getChannelList () {
      let v = this;
      var obj = {
        carrierId: v.carrId, // 物流商ID
        shippingMethodName: v.pageSearchParams.searchShipName ? v.pageSearchParams.searchShipName : null, // 渠道名称
        pageSize: v.channelParams.pageSize,
        pageNum: v.channelParams.pageNum
      };
      v.axios.post(api.get_channelList, obj)
        .then(res => {
          if (res.data.code === 0) {
            v.channelData = res.data.datas.list;
            v.channelTotal = res.data.datas.total;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 关闭计费模型弹框
    pricingCancel () {
      let v = this;
      v.pricingModal = false;
      v.editFlag = true;
    },
    channelChangePage (page, plat) { // 分页切换
      let v = this;
      v.channelParams.pageNum = page;
      if (plat === null || plat === undefined) {
        v.channelParamsStatus = true;
      }
    },
    channelChangePageSize (pageSize, plat) {
      let v = this;
      v.channelParams.pageSize = pageSize;
      v.channelParamsStatus = true;
    }
  },
  created () {
    this.tableHeight = this.getTableHeight(160);
    this.getList();
  },
  watch: {
    pageParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    channelParamsStatus (n, o) { // 监听重置列表数据
      let v = this;
      if (n) {
        v.getChannelList();
        v.channelParamsStatus = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/pricingModelManagement.vue